// extracted by mini-css-extract-plugin
export default {"icon":"NotSavedInfoMolecule_icon__Kdngc","iconWrapper":"NotSavedInfoMolecule_iconWrapper__iuJA1","textWrapper":"NotSavedInfoMolecule_textWrapper__OqCRK"};